<form [formGroup]="passwordForm" (ngSubmit)="onSave()" class="overflow-x-auto w-[60%] mt-1 mb-8 border-2 p-8 rounded-lg ml-auto mr-auto bg-white" >
  <p class="md:text-2xl text-xl text-left pt-2 mb-2 font-semibold">
    Change Password
  </p>
  <hr class="bg-green w-full min-w-[615px] h-[3px] border-none mb-6">
  <div class="grid gap-4">
    <!-- Current Password -->
    <mat-form-field appearance="fill" class="w-full">
      <mat-label>Current password</mat-label>
      <input
        matInput
        type="password"
        formControlName="currentPassword"
        required
        autocomplete="current-password"
        />
      @if (passwordForm.get('currentPassword')?.hasError('required')) {
        <mat-error>
          Current password is required.
        </mat-error>
      }
    </mat-form-field>

    <!-- New Password -->
    <mat-form-field appearance="fill" class="w-full mb-5" [subscriptSizing]="'dynamic'">
      <mat-label>New password</mat-label>
      <input
        matInput
        type="password"
        formControlName="newPassword"
        required
        minlength="10"
        autocomplete="new-password"
        />
      @if (passwordForm.get('newPassword')?.hasError('required')) {
        <mat-error>
          New Password is required.
        </mat-error>
      }
      @if (passwordForm.get('newPassword')?.hasError('minlength')) {
        <mat-error>
          Password must be at least 10 characters long.
        </mat-error>
      }
      @if (passwordForm.get('newPassword')?.hasError('pattern')) {
        <mat-error>
          Min 10 chars, with upper, lower, number & symbol.
        </mat-error>
      }
    </mat-form-field>

    <!-- Confirm Password -->
    <mat-form-field appearance="fill" class="w-full" [subscriptSizing]="'dynamic'">
      <mat-label>Confirm password</mat-label>
      <input
        matInput
        type="password"
        formControlName="confirmPassword"
        required
        autocomplete="confirm-password"
        />
      @if (passwordForm.get('confirmPassword')?.hasError('required')) {
        <mat-error>
          Confirm Password is required.
        </mat-error>
      }
      @if (passwordForm.get('confirmPassword')?.hasError('passwordMismatch') && (passwordForm.get('confirmPassword')?.touched || passwordForm.get('confirmPassword')?.dirty)) {
        <mat-error>
          Passwords do not match.
        </mat-error>
      }
    </mat-form-field>
    <div class="w-full flex items-center justify-between">
      <button
        type="button"
        (click)="onClose()"
        class="border-2 border-black bg-white text-black hover:bg-blue-800 disabled:opacity-60 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 mr-2 mb-2 focus:outline-none"
        >
        Cancel
      </button>

      <button
        type="submit"
        class="text-white bg-black hover:bg-blue-800 disabled:opacity-60 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 mr-2 mb-2 focus:outline-none"
        >
        Save
      </button>
    </div>

  </div>
</form>
